import cardStyles from "../../../styles/card.module.css";

export default function CardHeader({
  cardTitle,
  icon
}: {
  cardTitle: string;
  icon: React.ReactNode;
}) {
  return (
    <div className={cardStyles.cardHeader}>
      {icon}
      <p className={cardStyles.cardHeaderText}>{cardTitle}</p>
    </div>
  );
}
